<template>
  <div>
    <div class="mb-4">
      <button
        class="btn mr-2"
        :class="[priceCompareType === 'product'?'btn-primary':'btn-outline-primary']"
        @click.prevent="priceCompareType ='product'"
      >
        {{ $t('RFQOffersView.mhsulZr') }}
      </button>

      <button
        class="btn"
        :class="[priceCompareType === 'company'?'btn-primary':'btn-outline-primary']"
        @click.prevent="priceCompareType ='company'"
      >
        {{ $t('RFQOffersView.irktZr') }}
      </button>
    </div>
    <div v-if="priceCompareType === 'product'">
      <div
        v-for="p in products"
        :key="p.id"
      >
        <div
          v-if="request.requestType === 'RFQ'"
          class="card"
        >
          <div class="card-body">
            <div class="mb-3">
              <strong>{{ p.name }}</strong> <br>
              {{ p.count }} {{ p.unit }}
              <span v-if="p.note"><br>{{ p.note }}  </span>
            </div>
            <table class="table table-sm table-bordered table-striped">
              <thead>
                <tr>
                  <th>{{ $t('companyPage.irkt') }}</th>
                  <th>1 {{ p.unit }}</th>
                  <th>{{ $t('RFQOffersView.toplam') }}</th>
                </tr>
              </thead>

              <tbody>
                <template v-for="c in getProductPrices(p.id)">
                  <tr>
                    <td
                      class="pointer"
                      :rowspan="c.alternative?4:3"
                      @click="$emit('openCompanyRatingStatisticPopup',c.company.id)"
                    >
                      <strong>
                        {{ c.company.name }} {{ getCompanyFormat(c.company.format) }}
                      </strong> <br>
                      <StarRatingView
                        :count="c.company.supplyRateCount"
                        :total="c.company.supplyRateTotal"
                      />
                      <br>
                      <span>
                        {{ c.user.name }} {{ c.user.surname }} ({{ c.position }})
                      </span>
                    </td>
                    <td class=" text-right">
                      <strong>
                        {{ $t('RFQOffersView.cpriceAzn', {price:c.price}) }}
                      </strong>
                    </td>
                    <td class=" text-right">
                      <strong v-if="c.totalPrice">
                        {{ $t('RFQOffersView.ctotalpriceAzn' , {totalPrice:  c.totalPrice }) }}
                      </strong>
                      <strong v-else>
                        {{ $t('RFQOffersView.cpricePcountAzn', {price:c.price * p.count }) }} <br>
                        <em class="text-primary small">{{$t("myRfqOffer.hsblnmsh")}}</em>
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="text-center">
                        {{ getIsTaxIncluded(c.taxIncluded) }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="c.alternative"
                    class="text-danger"
                  >
                    <td colspan="2">
                      <strong>{{ $t('myRfqOffer.alternativMhsul') }}</strong> <br>
                      <strong> {{ c.alternative.name }} </strong> <br>
                      <strong> {{ $t('offerExtrasView.azn', {price: c.alternative.price}) }} </strong> <br>
                      <span>{{ $t('RFQOffersView.sbb', {reason: c.alternative.reason}) }}</span> <br>
                    </td>
                  </tr>

                  <tr>
                    <td
                      colspan="2"
                      class="text-right"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click.prevent="handleReportView(c.id)"
                      >
                        {{ $t('request.ikaytEt') }}
                      </button>

                      <router-link
                        v-if="getConversation(c)"
                        :to="`/dashboard/conversation/${getConversation(c).id}`"
                        class="btn btn-sm btn-primary ml-2"
                      >
                        <span v-if="getConversation(c).open">{{ $t('commentView.mzakiryDavamEt') }}</span>
                        <span v-else>{{ $t('commentView.mzakiryBax') }}</span>
                      </router-link>
                      <button
                        v-else
                        class="btn btn-sm btn-outline-primary ml-2"
                        @click="startConversation(c.id)"
                      >
                        {{ $t('commentView.mzakiryBala') }}
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="request.requestType === 'LOG'"
          class="card"
        >
          <div class="card-body">
            <div>
              <strong class="lead">{{ p.name }}</strong> ({{ p.count }} {{ p.unit }})
            </div>
            <div
              v-for="c in getLogisticPrices(p.id)"
              :key="c.id"
            >
              <hr>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <strong>
                    {{ c.company.name }} {{ getCompanyFormat(c.company.format) }}
                  </strong>
                  <span class="text-primary">
                    {{ c.user.name }} {{ c.user.surname }} ({{ c.position }})
                  </span>
                </div>
                <div class="col-md-12">
                  <table class="table table-sm table-bordered table-striped">
                    <tr
                      v-for="(v,k) in c.price"
                      :key="k"
                    >
                      <td>{{ getDeliveryTypeName(k) }}</td>
                      <td>
                        <div v-if="v.price<=0">
                          -
                        </div>
                        <div v-else>
                          <strong>{{ $t('offerExtrasView.azn', {price: v.price}) }}</strong>
                        </div>
                      </td>
                      <td>
                        <div v-if="v.price<=0">
                          -
                        </div>
                        <div v-else>
                          <em>{{ getIsTaxIncluded(c.taxIncluded) }}</em>
                        </div>
                      </td>
                      <td>
                        <div v-if="v.price<=0">
                          -
                        </div>
                        <div v-else>
                          {{ $t('myLogOffer.gn', {day: v.day}) }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-12 mt-2">
                  <router-link
                    v-if="getConversation(c)"
                    :to="`/dashboard/conversation/${getConversation(c).id}`"
                    class="btn btn-sm btn-primary"
                  >
                    <span v-if="getConversation(c).open">{{ $t('RFQOffersView.mzakiryDavamEt') }}</span>
                    <span v-else>{{ $t('RFQOffersView.mzakiryBax') }}</span>
                  </router-link>
                  <button
                    v-else
                    class="btn btn-sm btn-outline-primary"
                    @click="startConversation(c.id)"
                  >
                    {{ $t('commentView.mzakiryBala') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="priceCompareType === 'company'">
      <div
        v-for="c in comments"
        :key="c.id"
      >
        <div class="card">
          <div class="card-body">
            <div
              class="mb-3 pointer"
              @click="$emit('openCompanyRatingStatisticPopup',c.company.id)"
            >
              <strong>{{ c.company.name }} {{ getCompanyFormat(c.company.format) }}</strong> <br>
              <StarRatingView
                :count="c.company.supplyRateCount"
                :total="c.company.supplyRateTotal"
              />
            </div>

            <div v-if="request.requestType === 'RFQ'">
              <table class="table table-sm table-bordered table-striped">
                <thead>
                  <tr>
                    <th>{{ $t('RFQOffersView.mhsul') }}</th>
                    <th>{{ $t('RFQOffersView.1Dd') }}</th>
                    <th>{{ $t('RFQOffersView.toplam') }}</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-for="pc in getProductPricesByCompany(c.company.id)">
                    <tr>
                      <td rowspan="2">
                        <strong>{{ pc.product.name }}</strong> ({{ pc.product.count }} {{ pc.product.unit }})
                        <span v-if="pc.product.note"><br>{{ pc.product.note }}  </span>
                      </td>

                      <template v-if="!pc.alterative">
                        <td class=" text-right">
                          <strong>
                            {{ $t('RFQOffersView.pcpriceAzn',{price:pc.price}) }}
                          </strong>
                        </td>
                        <td class=" text-right">
                          <strong v-if="pc.totalPrice">
                            {{ $t('RFQOffersView.pctotalpriceAzn', {price:pc.totalPrice}) }}
                          </strong>
                          <strong v-else>
                            {{ $t('RFQOffersView.pcpricePcproductcountAzn' , {price:pc.price * pc.product.count}) }} <br>
                            <em class="text-primary small">{{$t("myRfqOffer.hsblnmsh")}}</em>
                          </strong>
                        </td>
                      </template>
                      <template v-else>
                        <td class="col-6 text-right text-danger">
                          <strong>{{ $t('myRfqOffer.alternativMhsul') }}</strong> <br>
                          <strong> {{ pc.alternative.name }} </strong> <br>
                          <span>{{ $t('RFQOffersView.sbb', {reason: pc.alternative.reason}) }}</span> <br>
                        </td>
                      </template>
                    </tr>
                    <tr v-if="pc.alternative">
                      <td class="text-right">
                        <strong> {{ $t('offerExtrasView.azn', {price: pc.alternative.price}) }} </strong> <br>
                      </td>
                      <td class=" text-right">
                        <strong v-if="pc.alternative.totalPrice">
                          {{ $t('RFQOffersView.pcalternativetotalpriceAzn', {price:pc.alternative.totalPrice}) }}
                        </strong>
                        <strong v-else>
                          {{ $t('RFQOffersView.pcalternativepricePcproductcountAzn',{price:pc.alternative.price * pc.product.count}) }} <br>
                          <em class="text-primary small">{{$t("myRfqOffer.hsblnmsh")}}</em>
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        class="text-center"
                      >
                        {{ getIsTaxIncluded(pc.taxIncluded) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr class="lead">
                    <th>{{ $t('RFQOffersView.toplam') }}</th>
                    <th
                      class="text-right"
                      colspan="2"
                    >
                      <strong>
                        {{ $t('RFQOffersView.gettotalcompanypricecAzn' , {price: getTotalCompanyPrice(c)}) }}
                      </strong>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div v-if="request.requestType === 'LOG'">
              <div
                v-for="pc in getLogisticPricesByCompany(c.company.id)"
                :key="pc.id"
              >
                <hr>

                <div class="row">
                  <div class="col-12 mb-2">
                    <strong>{{ pc.product.name }}</strong> ({{ pc.product.count }} {{ pc.product.unit }})
                    <span v-if="pc.product.note"><br>{{ pc.product.note }}  </span>
                  </div>
                  <div class="col-md-12">
                    <table class="table table-sm table-bordered table-striped">
                      <tr
                        v-for="(v,k) in pc.price"
                        :key="k"
                      >
                        <td>{{ getDeliveryTypeName(k) }}</td>
                        <td>
                          <div v-if="v.price<=0">
                            -
                          </div>
                          <div v-else>
                            <strong>{{ $t('offerExtrasView.azn', {price: v.price}) }}</strong>
                          </div>
                        </td>
                        <td>
                          <div v-if="v.price<=0">
                            -
                          </div>
                          <div v-else>
                            <em>{{ getIsTaxIncluded(c.taxIncluded) }}</em>
                          </div>
                        </td>
                        <td>
                          <div v-if="v.price<=0">
                            -
                          </div>
                          <div v-else>
                            {{ $t('myLogOffer.gn', {day: v.day}) }}
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button
              v-b-modal.modal-comment-report
              type="button"
              class="btn btn-sm btn-danger mr-2"
              @click.prevent="handleReportView(c.id)"
            >
              {{ $t('request.ikaytEt') }}
            </button>

            <router-link
              v-if="getConversation(c)"
              :to="`/dashboard/conversation/${getConversation(c).id}`"
              class="btn btn-sm btn-primary ml-2"
            >
              <span v-if="getConversation(c).open">{{ $t('commentView.mzakiryDavamEt') }}</span>
              <span v-else>{{ $t('commentView.mzakiryBax') }}</span>
            </router-link>
            <button
              v-else
              class="btn btn-sm btn-outline-primary ml-2"
              @click="startConversation(c.id)"
            >
              {{ $t('commentView.mzakiryBala') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="request.requestType === 'RFQ'"
      class="card"
    >
      <div class="card-body">
        <button
          class="btn btn-outline-primary mr-2"
          @click.prevent="exportResults('xlsx')"
        >
          {{ $t('PQTOffersView.excelXar') }}
        </button>
        <button
          class="btn btn-outline-danger mr-2"
          @click.prevent="exportResults('pdf')"
        >
          {{ $t('PQTOffersView.pdfXar') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue"
import {exportRequestResult, startConversation} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {
  buildLongId,
  getCompanyFormat,
  getDeliveryTypeName,
  getIsTaxIncluded, getLoadTypeName,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";
import {mapState} from "vuex";

export default {
  name: 'RFQOffersView',
  components: {StarRatingView},
  props: {
    request: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    comments: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    products: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    conversations: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      priceCompareType: 'product'
    }
  },
  computed:{
    ...mapState({
      token: state => state.auth.token,
    })
  },
  methods: {

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },


    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getIsTaxIncluded(value) {
      return getIsTaxIncluded(parseInt(value), this.$i18n);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getDeliveryTypeName(key) {
      return getDeliveryTypeName(key);
    }, getLoadTypeName(key) {
      return getLoadTypeName(key);
    },

    getConversation(comment) {

      let conversation = null;
      this.conversations.forEach(c => {
        if (comment.user.id === c.user.id && comment.company.id === c.company.id && comment.profileType === c.profileType) {
          conversation = c;
        }
      })
      return conversation;
    },


    startConversation(id) {

      startConversation(this.token, id).then(data => {

        if (data.code === 200) {
          this.$router.push(`/dashboard/conversation/${data.id}`);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      });
    },

    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },


    getProductPrices(productId) {

      let prices = [];

      this.comments.forEach(c => {

        let json = JSON.parse(c.commentData);

        if (json !== null) {

          if (json.hasOwnProperty("prices")) {
            //new version
            let alternative = null;
            if (json.hasOwnProperty("alternative") && json.alternative[productId]) {
              alternative = json.alternative[productId]
            }
            prices.push({
              id: c.id,
              user: c.user,
              company: c.company,
              position: c.position,
              profileType: c.profileType,
              price: json['prices'][productId + ""],
              totalPrice: json['totalPrices'] ? json['totalPrices'][productId + ""] : null,
              alternative: alternative,
              taxIncluded: json['taxIncluded'][productId + ""]
            })

          } else {
            //old version

            prices.push({
              user: c.user,
              company: c.company,
              position: c.position,
              profileType: c.profileType,
              price: json['prices'][productId + ""],
              alternative: null,
              taxIncluded: -1
            })
          }
        }

      })

      return prices;

    },

    getProductPricesByCompany(companyId) {

      let prices = [];

      this.comments.forEach(c => {

        if (c.company.id === companyId) {
          let json = JSON.parse(c.commentData);

          this.products.forEach((p) => {

            if (json.hasOwnProperty("prices")) {
              //new version
              let alternative = null;
              if (json.hasOwnProperty("alternative") && json.alternative[p.id]) {
                alternative = json.alternative[p.id]
              }
              prices.push({
                id: p.id,
                product: p,
                price: json['prices'][p.id + ""],
                totalPrice: json['totalPrices'] ? json['totalPrices'][p.id + ""] : null,
                alternative: alternative,
                taxIncluded: json['taxIncluded'][p.id + ""]
              })

            } else {
              //old version

              prices.push({
                id: p.id,
                product: p,
                price: json['prices'][p.id + ""],
                alternative: null,
                taxIncluded: -1
              })
            }
          })
        }
      })
      return prices;
    },
    getTotalCompanyPrice(c) {

      let price = 0;
      let json = JSON.parse(c.commentData);

      this.products.forEach((p) => {
        if (json.hasOwnProperty("totalPrices") && json['totalPrices'][p.id + ""]) {
          //new version
          price += parseFloat(json['totalPrices'][p.id + ""]);
        } else if (json.hasOwnProperty("prices")) {
          //new version
          price += parseFloat(json['prices'][p.id + ""]) * p.count;
        } else {
          //old version
          price += parseFloat(json[p.id + ""]);
        }
      })
      return price;
    },

    getLogisticPricesByCompany(companyId) {

      let prices = [];

      this.comments.forEach(c => {

        if (c.company.id === companyId) {

          let json = JSON.parse(c.commentData);

          this.products.forEach(p => {
            prices.push({
              id: p.id,
              product: p,
              price: json['prices'][p.id + ""],
            })
          });
        }
      })
      return prices;
    },

    getLogisticPrices(productId) {

      let prices = [];
      this.comments.forEach(c => {
        let json = JSON.parse(c.commentData);
        prices.push({
          id: c.id,
          user: c.user,
          company: c.company,
          position: c.position,
          profileType: c.profileType,
          price: json['prices'][productId + ""],
        })
      })
      return prices;
    },
    exportResults(format) {

      exportRequestResult(this.token, this.request.id, format).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });

    },

    handleReportView(commentId) {
      this.$emit('reportComment', commentId);
    }

  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
